import { computed } from 'vue';
import { useProductPrice } from '~/modules/price/composables/useProductPrice';
import { useProduct } from '~/modules/product/composables/useProduct';

/**
 * * Get the product price for the ATB
 */
export const useATBPriceBCOM = () => {
  const { productData } = useProduct();

  const selectedPrice = useProductPrice();

  return computed(() => selectedPrice.value || productData.pricing.price);
};
